import {
    BQ_CLICKED_CUSTOM_ORDER,
    BQ_CLICKED_PACKAGE_SELECT,
    BQ_CLICKED_REPORT_GIG,
    BQ_GIG_DESCRIPTION_SEE_MORE,
    BQ_CLICKED_CONTACT_SELLER,
    BQ_CLICKED_PACKAGES_TAB,
    BQ_CLICKED_REVIEWS_SNIPPET_MORE
} from '../bigQueryEvents';

export const PAGE_NAME = 'gig_page';

export const clickActionData = {
    group: 'user_actions',
    sub_group: 'website_actions',
    action: {
        type: 'click'
    },
    entity: 'client',
    out_of_session: false
};

export const createBqPackageSelectParams = (data) => ({
    type: BQ_CLICKED_PACKAGE_SELECT,
    group: data.source,
    gig: { id: data.gigId },
    aux: { package_selected: data.id }
});

export const createBqCustomOrderClickParams = (data) => ({
    type: BQ_CLICKED_CUSTOM_ORDER,
    group: PAGE_NAME,
    gig: { id: data.gigId },
    page: {
        element: {
            type: 'button',
            text: 'get_a_quote'
        }
    }
});

export const createBqReportGigClickParams = (data) => ({
    type: BQ_CLICKED_REPORT_GIG,
    group: PAGE_NAME,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    out_of_session: false,
    entity: 'client'
});

export const createBqDescriptionSeeMoreParams = (data) => ({
    type: BQ_GIG_DESCRIPTION_SEE_MORE,
    group: PAGE_NAME,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        element: {
            type: 'text',
            name: 'see_more_gig_description'
        },
        component: {
            name: 'gig_description'
        }
    },
    ...clickActionData
});

export const createBqContactSellerClickParams = (data) => ({
    type: BQ_CLICKED_CONTACT_SELLER,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        name: PAGE_NAME,
        element: {
            type: 'button'
        },
        component: {
            name: data.name
        }
    },
    ...clickActionData
});

export const createBqClickedPackagesTab = (data) => ({
    type: BQ_CLICKED_PACKAGES_TAB,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        name: PAGE_NAME,
        element: {
            type: 'tab',
            ...data.page.element
        }
    },
    ...clickActionData
});

export const createBqReviewsSnippetMoreClickParams = (data) => ({
    type: BQ_CLICKED_REVIEWS_SNIPPET_MORE,
    gig: { id: data.gigId },
    seller: { id: data.sellerId },
    page: {
        element: {
            type: 'button',
            name: 'reviews snippet'
        },
        component: {
            name: data.name
        }
    },
    domain: {
        name: 'quality'
    },
    publisher: {
        domain: 'algos',
        sub_domain: 'quality'
    },
    ...clickActionData
});

export const createGigGalleryReportParams = (data) => ({
    type: data.type,
    group: 'gig_page_gallery',
    gig: {
        id: data.gigId,
        gallery: {
            item: data.source
        }
    }
});
